export default __webpack_public_path__ + "static/media/bluish-green-1.995a6423.jpg";